/**
 * @format
 */
import React from 'react';
import {
  Alert,
  Box,
  Paper,
  Snackbar,
  Tab,
  Tabs,
  Typography,
} from '@mui/material';
import ModeButtons from '../Home/components/ModeButtons';
import { managementPageShellSx } from './managementPageLayout';
import PageCloseButton from './PageCloseButton';

export default function ManagementPage({
  title,
  icon,
  toolbar = null,
  tabs = null,
  tabIndex,
  onTabChange,
  children,
  snackbar = null,
  onSnackbarClose,
}) {
  const hasTabs = Array.isArray(tabs) && tabs.length > 0;

  return (
    <Box aria-label="management page" sx={managementPageShellSx.root}>
      <Box sx={managementPageShellSx.modeButtonsWrap}>
        <ModeButtons />
      </Box>

      <Box sx={managementPageShellSx.contentWrap}>
        <Paper elevation={0} sx={managementPageShellSx.paper}>
          <Box sx={managementPageShellSx.header}>
            {icon &&
              React.cloneElement(icon, {
                sx: {
                  ...managementPageShellSx.headerIcon,
                  ...(icon.props?.sx || {}),
                },
              })}
            <Typography
              variant="h6"
              fontWeight={managementPageShellSx.headerTitle.fontWeight}
              fontSize={managementPageShellSx.headerTitle.fontSize}
            >
              {title}
            </Typography>
            <PageCloseButton sx={managementPageShellSx.headerCloseButton} />
          </Box>

          {hasTabs && (
            <Tabs
              value={tabIndex}
              onChange={(_, value) => onTabChange?.(value)}
              variant="fullWidth"
              textColor="inherit"
              sx={{
                ...managementPageShellSx.tabs,
                // container so tabs can position their glass bg
                '& .MuiTabs-flexContainer': {
                  gap: 1,
                },
                '& .MuiTab-root': {
                  borderRadius: '12px',
                  minHeight: 40,
                  transition: 'all 0.25s ease',
                  color: 'rgba(255, 255, 255, 0.7)',
                },
                '& .Mui-selected': {
                  color: '#fff !important',
                  background: 'rgba(255, 255, 255, 0.15)',
                  backdropFilter: 'blur(12px)',
                  WebkitBackdropFilter: 'blur(12px)', // Safari
                  border: '1px solid rgba(255, 255, 255, 0.25)',
                  boxShadow: '0 4px 16px rgba(0, 0, 0, 0.1)',
                },
                // hide default indicator since the bg itself indicates selection
                '& .MuiTabs-indicator': {
                  display: 'none',
                },
              }}
            >
              {tabs.map((tab) => (
                <Tab
                  key={tab.value}
                  value={tab.value}
                  icon={
                    tab.icon
                      ? React.cloneElement(tab.icon, {
                          sx: {
                            ...managementPageShellSx.tabIcon,
                            ...(tab.icon.props?.sx || {}),
                          },
                        })
                      : undefined
                  }
                  label={tab.label}
                />
              ))}
            </Tabs>
          )}

          {toolbar}

          <Box sx={managementPageShellSx.scrollContent}>{children}</Box>

          {snackbar && (
            <Snackbar
              open={snackbar.open}
              autoHideDuration={3500}
              onClose={onSnackbarClose}
              anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            >
              <Alert severity={snackbar.severity} onClose={onSnackbarClose}>
                {snackbar.message}
              </Alert>
            </Snackbar>
          )}
        </Paper>
      </Box>
    </Box>
  );
}
